/** Build production Vite — masque aides dev / identifiants démo. */
export const isProductionBuild = import.meta.env.PROD;

/**
 * Identifiants démo sur /login — désactivé par défaut (pilote & prod).
 * Local uniquement : VITE_SUITE_SHOW_DEMO_HINTS=true dans .env
 */
export const showSuiteDevHints =
  import.meta.env.VITE_SUITE_SHOW_DEMO_HINTS === "true" ||
  import.meta.env.VITE_SUITE_SHOW_DEMO_HINTS === "1";
